"use client";

export { Root as Separator } from "@radix-ui/react-separator";
